import React, {useState, createContext} from 'react'
import axios from "../api/axios";

const UserContext = createContext({});

export const UserContextProvider = (props) => {

	const [accessToken, setAccessToken] = useState(null);
	const [loginStatus, setLoginStatus] = useState("loading");
	const [isAuth, setIsAuth] = useState(false);

	const getRequestAuthHeader = () => {
		return {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${accessToken}`
		};
	}

	const checklocalStorage = () => {

		let token = localStorage.getItem('token');

		if(token !== null && token.length){
			return {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			};
		} 
		return getRequestAuthHeader();
	}

	const checkToken = () => {
		const options = {
			url: '/auth/check-token',
			method: 'get',
			headers: checklocalStorage()
		};
		
		return axios(options)
			.then((res) => {
				setIsAuth(res.data.response);
				setLoginStatus('success');
			})
    	.catch((error) => { 
			console.log(error); 
		 });
	}

	const processLogin = (email, password) => {

		axios.post('/auth/login',  {
			email: email,
			password: password
		})
		.then((res) => {

			console.log('login response: ' + res.data);

			if (res.data) {
				setAccessToken(res.data.response);
				setLoginStatus("success");
				setIsAuth(true); // Set isAuth to true on successful logi
				window.localStorage.setItem('token', res.data.response);
			}
		})
		.catch((error) => { 
			console.log(error);
			setLoginStatus("error") 
		});
	}

	const isAuthenticated = () => {
		if (accessToken) {
			return true;
		}
		return false;
	};
	 
	return (
		<UserContext.Provider 
			value={{
				processLogin: processLogin,
				loginStatus: loginStatus,
				setLoginStatus: setLoginStatus,
				isAuthenticated: isAuthenticated,
				checkToken: checkToken,
				isAuth: isAuth,
				checklocalStorage: checklocalStorage
			}}
		>
			{props.children}
		</UserContext.Provider>
	)
}
 
export default UserContext;
  